import {
    CreditCard,
    Truck,
    Wallet,
    LayoutDashboard,
    Globe,
    Boxes,
} from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";

const BENEFITS = [
    {
        icon: Wallet,
        title: "Sin renta mensual",
        body: "Usar Tiendify no te cuesta nada al mes y no te cobramos comisión por lo que vendas. Lo que ganas es tuyo.",
    },
    {
        icon: CreditCard,
        title: "Cobra con tarjeta",
        body: "Acepta tarjetas de crédito y débito desde el primer día. El cobro es seguro y tú no tramitas nada con el banco.",
    },
    {
        icon: Truck,
        title: "Envíos a todo México",
        body: "Tarifas negociadas con las principales paqueterías del país. Generas la guía desde el panel y solo entregas el paquete.",
    },
    {
        icon: LayoutDashboard,
        title: "Todo en un panel",
        body: "Productos, inventario, pedidos, guías y estados de envío en un mismo lugar. Sin hojas de cálculo ni apps sueltas.",
    },
    {
        icon: Globe,
        title: "Tu propia dirección web",
        body: "Tu tienda vive en una dirección que puedes compartir en redes, en WhatsApp o en tu tarjeta de presentación.",
    },
    {
        icon: Boxes,
        title: "Sin límite de productos",
        body: "Sube los productos que quieras, con variantes de talla y color, fotos e inventario. Sin planes ni topes.",
    },
];

export default function Benefits() {
    const reduce = useReducedMotion();
    return (
        <section
            id="beneficios"
            data-testid="home-benefits"
            className="py-20 sm:py-28 lg:py-32 bg-[#F6F6F3]"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl mx-auto text-center">
                    <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">
                        Por qué Tiendify
                    </p>
                    <h2 className="mt-4 text-4xl sm:text-5xl lg:text-[3.5rem] font-extrabold tracking-[-0.03em] leading-[1.02] text-[#1A1A1A] text-balance">
                        Todo lo que necesitas para vender
                    </h2>
                    <p className="mt-5 text-lg text-[#4A4A4A] leading-relaxed">
                        Hecho para quien está empezando: lo complicado lo
                        resolvemos nosotros, tú te dedicas a vender.
                    </p>
                </div>

                <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
                    {BENEFITS.map((b, i) => (
                        <motion.div
                            key={b.title}
                            initial={reduce ? false : { opacity: 0, y: 16 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{
                                duration: reduce ? 0 : 0.45,
                                delay: reduce ? 0 : Math.min(i * 0.06, 0.3),
                                ease: "easeOut",
                            }}
                            className="rounded-3xl bg-white p-8 lg:p-9"
                        >
                            <div className="w-11 h-11 rounded-xl bg-primary-subtle grid place-items-center">
                                <b.icon className="w-5 h-5 text-primary" aria-hidden="true" />
                            </div>
                            <h3 className="mt-5 text-xl font-bold tracking-[-0.02em] text-[#1A1A1A]">
                                {b.title}
                            </h3>
                            <p className="mt-2.5 text-[15px] text-[#4A4A4A] leading-relaxed">
                                {b.body}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
